<template>
	<Water>
		<template #header>
			<Header />
		</template>
	</Water>
</template>

<script setup lang="ts">
import Header from "@/rmo/components/Header.vue";
import Water from "@/rmo/content/Water.vue";
</script>
